import styled from 'styled-components';

/* types */
import { FormProps } from '../../';

export const StyledForm = styled.form<FormProps>``;
